<template>
  <v-container fluid>
    <PageTitle>
      Mailgun Domains
    </PageTitle>

    <ErrorAlert :error="error">
    </ErrorAlert>

    <v-card :loading="busy">
      <v-simple-table v-if="!busy">
        <thead>
        <tr>
          <th style="max-width: 40%;">
            Domain
          </th>
          <th class="text-center">
            Secure Links
          </th>
          <th class="text-center">
            Verified
          </th>
          <th v-for="ipAddress in ipAddresses"
              :key="ipAddress.ip"
              class="text-center">
            <div>
              Dedicated IP
            </div>
            <div>
              {{ ipAddress.ip }}
            </div>
          </th>
          <th v-for="ipPool in ipPools"
              :key="ipPool.pool_id"
              class="text-center">
            <div>
              IP Pool
            </div>
            <div>
              {{ ipPool.name }}
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="domain in domains"
            :key="domain.id">
          <td style="max-width: 40%;">
            {{ domain.name }}
          </td>
          <td class="text-center">
            <v-icon v-if="domain.web_scheme === 'https'"
                    color="success">
              fas fa-fw fa-lock
            </v-icon>
            <v-icon v-else
                    color="warning">
              fas fa-fw fa-lock-open
            </v-icon>
          </td>
          <td>
            <div class="d-flex justify-center align-center">
              <v-icon v-if="domain.state === 'active'"
                      color="success">
                fas fa-fw fa-check-circle
              </v-icon>
              <v-icon v-else-if="domain.state === 'unverified'"
                      color="warning">
                fas fa-fw fa-exclamation-triangle
              </v-icon>
            </div>
          </td>
          <td v-for="ipAddress in ipAddresses"
              :key="ipAddress.ip">
            <div class="d-flex justify-center align-center">
              <v-icon v-if="domain.ip_addresses.includes(ipAddress.ip)"
                      color="success">
                fas fa-fw fa-check-circle
              </v-icon>
            </div>
          </td>
          <td v-for="ipPool in ipPools"
              :key="ipPool.pool_id">
            <div class="d-flex justify-center align-center">
              <v-icon v-if="domain.ip_pools.includes(ipPool.pool_id)"
                      color="success">
                fas fa-fw fa-check-circle
              </v-icon>
            </div>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import mailgunAdminService from '../../../services/mailgunAdminService';
import PageTitle from '../../../components/PageTitle.vue';
import {orderBy} from 'lodash';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert, PageTitle},
  data() {
    return {
      busy: false,
      error: null,
      domains: [],
      ipAddresses: [],
      ipPools: [],
    }
  },
  computed: {
    ...mapGetters([]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.busy = true;
      try {
        const [domains, ipAddresses, ipPools] = await Promise.all([
          this.fetchDomains(),
          this.fetchIPAddresses(),
          this.fetchIPPools()
        ]);

        this.domains = orderBy(domains, ['name'], ['asc']).map(domain => {
          return {
            ...domain,
            ip_addresses: this.findIPsWithDomain(domain.name, ipAddresses),
            ip_pools: this.findPoolsWithDomain(domain.name, ipPools),
          }
        });
        this.ipAddresses = ipAddresses;
        this.ipPools = ipPools;
      } catch (error) {
        this.error = error;
      } finally {
        this.busy = false;
      }
    },
    async fetchDomains() {
      return await mailgunAdminService.getDomains();
    },
    findPoolsWithDomain(domain, ipPools = this.ipPools) {
      return ipPools
        .filter(ipPool => ipPool.linked_domains.includes(domain))
        .map(ipPool => ipPool.pool_id);
    },
    findIPsWithDomain(domain, ipAddresses = this.ipAddresses) {
      return ipAddresses
        .filter(ipAddress => ipAddress.domains.includes(domain))
        .map(ipAddress => ipAddress.ip);
    },
    async fetchIPAddresses() {
      const ips = await mailgunAdminService.getIPAddresses();
      const domainPromises = ips.map(ip => mailgunAdminService.getDomainsFor(ip));
      const domainsArrays = await Promise.all(domainPromises);

      return ips.map((ip, index) => ({
        ip: ip,
        details: null,
        domains: domainsArrays[index],
      }));
    },
    async fetchIPPools() {
      const pools = await mailgunAdminService.getIPPools();
      const poolPromises = pools.map(pool => mailgunAdminService.getIPPool(pool.pool_id));
      return await Promise.all(poolPromises);
    },
  }
}
</script>
